import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Search from '@material-ui/icons/Search';
import classNames from 'classnames';

import GlobalMenu from 'src/ui/library/GlobalMenu/GlobalMenuContainer';
import intl from 'react-intl-universal';

const HeaderPres = ({ headerName, isMobile }) => {
  const headerClass = classNames('header-container', {
    'header-mobile': isMobile,
  });

  const currentlocation = window.location.href;
  const showdashboard = currentlocation.includes('/powerbi');

  return showdashboard && showdashboard ? null : (
    <Fragment>
      <header className={headerClass}>
        <Grid className="logo-container">
          <div className="logo-image">
            <img alt="Logo" src={process.env.PUBLIC_URL + '/images/EYLogo.svg'} />
          </div>
          <Hidden mdDown>
            <span className="header-iml">
              <span className="header-text">{intl.get('header.headerName')}</span>
            </span>
          </Hidden>
          <Hidden mdUp>
            <span className="title-mobile">{headerName}</span>
          </Hidden>
          <nav className="nav-bar">
            <div className="header-button">
              <Search className="icon md" />
            </div>
            <GlobalMenu />
          </nav>
        </Grid>
        <Hidden mdDown>
          <h2 className="title">{headerName}</h2>
        </Hidden>
      </header>
    </Fragment>
  );
};

HeaderPres.propTypes = {
  headerName: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default HeaderPres;



// WEBPACK FOOTER //
// ./src/ui/layout/Header/HeaderPres.js